import { render } from "./FloatingButton.vue?vue&type=template&id=56162bbe&scoped=true"
import script from "./FloatingButton.vue?vue&type=script&lang=js"
export * from "./FloatingButton.vue?vue&type=script&lang=js"

import "./FloatingButton.vue?vue&type=style&index=0&id=56162bbe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56162bbe"]])

export default __exports__